import { FaInfoCircle } from 'react-icons/fa';

const InfoMessage = () => (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 rounded-lg shadow-md">
        <div className="flex items-center">
            <div className="bg-yellow-400 p-2 rounded-full mr-3">
                <FaInfoCircle className="text-yellow-700 w-6 h-6" />
            </div>
            <div>
                <p className="text-yellow-700 font-semibold">Note :</p>
                <p className="text-yellow-700">Seuls les 100 derniers contrats enregistrés sont affichés ici. Utilisez la fonction de recherche pour afficher plus de contrats.</p>
            </div>
        </div>
    </div>
);

export default InfoMessage;
